import React from 'react';
import { ShieldCheck, Clock, RefreshCw, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="w-full py-20 px-4 bg-gradient-to-b from-[#0a0a0a] via-[#0f0d08] to-[#0a0a0a]" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-[#111] border-2 border-[#D4AF37]/40 rounded-3xl p-8 sm:p-12 text-center overflow-hidden" data-id="element-158">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#D4AF37]/5 rounded-full blur-3xl -z-0 pointer-events-none" data-id="element-159" />

          <div className="relative z-10" data-id="element-160">
            {/* Shield Icon */}
            <div className="mx-auto w-20 h-20 rounded-full bg-gradient-to-br from-[#D4AF37]/20 to-[#D4AF37]/5 border-2 border-[#D4AF37]/50 flex items-center justify-center mb-8 shadow-[0_0_40px_rgba(212,175,55,0.15)]" data-id="element-161">
              <ShieldCheck className="w-10 h-10 text-[#D4AF37]" strokeWidth={1.5} data-id="element-162" />
            </div>

            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full px-5 py-2 mb-6" data-id="element-163">
              <Clock className="w-4 h-4 text-[#D4AF37]" data-id="element-164" />
              <span className="font-inter text-[#D4AF37] text-sm font-bold uppercase tracking-wider" data-id="element-165">
                Garantía de 7 Días
              </span>
            </div>

            <h2 className="font-playfair text-3xl sm:text-4xl text-white mb-4" data-id="element-166">
              Tu inversión está{' '}
              <span className="text-gradient-gold italic" data-id="element-167">100% protegida</span>
            </h2>

            <p className="font-inter text-gray-300 text-base sm:text-lg leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-168">
              Si dentro de los primeros{' '}
              <strong className="text-white" data-id="element-169">7 días</strong> no ves resultados o
              sentís que tu limpia no te brindó la claridad que buscabas, te
              devuelvo tu dinero. Sin preguntas, sin excusas, sin
              complicaciones.
            </p>

            {/* Trust points */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-8" data-id="element-170">
              <div className="flex flex-col items-center gap-2 bg-white/5 rounded-xl p-4 border border-white/5" data-id="element-171">
                <RefreshCw className="w-6 h-6 text-[#D4AF37]" data-id="element-172" />
                <span className="font-inter text-sm text-gray-300 font-medium" data-id="element-173">
                  Reembolso completo
                </span>
                <span className="font-inter text-xs text-gray-500" data-id="element-174">
                  Sin letra chica
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 bg-white/5 rounded-xl p-4 border border-white/5" data-id="element-175">
                <Clock className="w-6 h-6 text-[#D4AF37]" data-id="element-176" />
                <span className="font-inter text-sm text-gray-300 font-medium" data-id="element-177">
                  7 días de plazo
                </span>
                <span className="font-inter text-xs text-gray-500" data-id="element-178">
                  Tiempo suficiente para evaluar
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 bg-white/5 rounded-xl p-4 border border-white/5" data-id="element-179">
                <CheckCircle className="w-6 h-6 text-[#D4AF37]" data-id="element-180" />
                <span className="font-inter text-sm text-gray-300 font-medium" data-id="element-181">
                  +10,000 clientas
                </span>
                <span className="font-inter text-xs text-gray-500" data-id="element-182">
                  Menos del 0.5% pidió reembolso
                </span>
              </div>
            </div>

            <p className="font-inter text-gray-500 text-xs" data-id="element-183">
              En más de 10 años de experiencia, menos del 0.5% de mis clientas
              necesitó usar esta garantía. Estás en buenas manos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}